import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableSortLabel from "@mui/material/TableSortLabel";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { sha256 } from "js-sha256";
import { getVoucherDetails } from "../../../redux/actions/voucherActions";
import getSymbolFromCurrency from "currency-symbol-map";
// import { Empty } from "antd";

const useRowStyles = makeStyles({
	root: {
		"& > *": {
			// borderBottom: "unset",
		}
	}
});

function Row(props) {
	const { row } = props;
	const [open, setOpen] = useState(false);
	const [vId, setVoucherId] = useState("");

	const {
		data: { customerId, secKey }
	} = useSelector((state) => state.login);

	const { data } = useSelector((state) => state.getVoucherDetails);

	const dispatch = useDispatch();
	const classes = useRowStyles();

	const fetchVoucherDetails = (id) => {
		const verificationHash = sha256(secKey + customerId + id);

		const request = {
			customer: { customerId: customerId },
			voucherId: id,
			verificationHash: verificationHash
		};
		dispatch(getVoucherDetails(request));
	};

	const onButtonClick = (data) => {
		setOpen(!open);
		setVoucherId(data.voucherId);
	};

	useEffect(() => {
		if (open && vId) {
			fetchVoucherDetails(vId);
		} else {
			setVoucherId("");
		}
	}, [open, vId]);

	return (
		<React.Fragment>
			<TableRow className={classes.root}>
				<TableCell>
					<IconButton
						aria-label="expand row"
						size="small"
						onClick={() => onButtonClick(row)}
					>
						{open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
					</IconButton>
				</TableCell>
				<TableCell component="th" scope="row">
					{row.voucherNumber}
				</TableCell>
				<TableCell>
					{row.currency == "" || row.amount == ""
						? ""
						: getSymbolFromCurrency(row.currency) + " " + row.amount}
					{/* {getSymbolFromCurrency(row.currency) + " " + row.amount} */}
				</TableCell>
				{/* <TableCell>{row.status}</TableCell> */}
				<TableCell>{row.activationDate}</TableCell>
				<TableCell>{row.redeemDate}</TableCell>
				<TableCell>{row.expirationDate}</TableCell>
			</TableRow>

			<TableRow>
				<TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
					<Collapse in={open} timeout="auto" unmountOnExit>
						<Box margin={4}>
							<Typography
								variant="h6"
								gutterBottom
								component="div"
								style={{ paddingBottom: "17px", fontSize: "1.1rem" }}
							>
								<strong>Voucher Info</strong>
							</Typography>
							<Table size="medium" aria-label="purchases" className="my-4">
								<TableHead>
									<TableRow>
										<TableCell style={{ paddingBottom: "10px" }}>
											Voucher Number
										</TableCell>
										<TableCell style={{ paddingBottom: "10px" }}>
											Amount
										</TableCell>
										<TableCell style={{ paddingBottom: "10px" }}>
											Status
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									<TableRow>
										<TableCell>
											{data.voucherDetails &&
												data.voucherDetails.voucher.voucherNumber}
										</TableCell>
										<TableCell>
											{data.voucherDetails &&
												data.voucherDetails.voucher.amount}
										</TableCell>
										<TableCell>
											{data.voucherDetails &&
												data.voucherDetails.voucher.status}
										</TableCell>
									</TableRow>
								</TableBody>
							</Table>

							{data.voucherDetails &&
							data.voucherDetails.voucher.status == "FAILED" ? (
								""
							) : (
								<Table size="medium" aria-label="purchases">
									<TableHead>
										<TableRow>
											<TableCell style={{ paddingBottom: "10px" }}>
												Creation Date
											</TableCell>
											<TableCell style={{ paddingBottom: "10px" }}>
												Activation Date
											</TableCell>
											<TableCell style={{ paddingBottom: "10px" }}>
												Expiry Date
											</TableCell>
											<TableCell
												align="right"
												style={{ paddingBottom: "10px" }}
											>
												Redeem Date
											</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										<TableRow>
											<TableCell>
												{data.voucherDetails &&
													data.voucherDetails.voucher.creationDate}
											</TableCell>
											<TableCell>
												{data.voucherDetails &&
													data.voucherDetails.voucher.activationDate}
											</TableCell>
											<TableCell>
												{data.voucherDetails &&
													data.voucherDetails.voucher.expirationDate}
											</TableCell>
											<TableCell>
												{data.voucherDetails &&
													data.voucherDetails.voucher.redeemDate}
											</TableCell>
										</TableRow>
									</TableBody>
								</Table>
							)}

							<Typography
								variant="h6"
								component="div"
								className="mt-3"
								style={{
									paddingBottom: "10px",
									paddingTop: "30px",
									fontSize: "1.1rem"
								}}
							>
								<strong>Transaction Info</strong>
							</Typography>
							<Table size="medium" aria-label="purchases">
								<TableHead>
									<TableRow>
										<TableCell>Transaction ID</TableCell>
										<TableCell>Voucher Amount</TableCell>
										<TableCell>Redeem Amount</TableCell>
										<TableCell>Merchant Amount</TableCell>
										<TableCell>Status</TableCell>
										<TableCell>Transaction Date</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{data.voucherDetails &&
										data.voucherDetails.voucher &&
										data.voucherDetails.voucher.transactionDetails &&
										[]
											.concat(data.voucherDetails.voucher.transactionDetails)
											.map((detail) => {
												return (
													<TableRow key={detail.trackingId}>
														<TableCell>{detail.trackingId}</TableCell>
														<TableCell>{detail.voucherAmount}</TableCell>
														<TableCell>{detail.redeemAmount}</TableCell>
														<TableCell>{detail.merchantAmount}</TableCell>
														<TableCell>{detail.status}</TableCell>
														<TableCell>{detail.transactionDate}</TableCell>
													</TableRow>
												);
											})}
								</TableBody>

								{/* <TableBody>
                  <TableRow>
                    <TableCell>
                      {data.voucherDetails &&
                        data.voucherDetails.voucher.transactionDetails
                          .trackingId}
                    </TableCell>
                    <TableCell>
                      {data.voucherDetails &&
                        data.voucherDetails.voucher.transactionDetails
                          .voucherAmount}
                    </TableCell>
                    <TableCell>
                      {data.voucherDetails &&
                        data.voucherDetails.voucher.transactionDetails
                          .redeemAmount}
                    </TableCell>
                    <TableCell>
                      {data.voucherDetails &&
                        data.voucherDetails.voucher.transactionDetails
                          .merchantAmount}
                    </TableCell>
                    <TableCell>
                      {data.voucherDetails &&
                        data.voucherDetails.voucher.transactionDetails.status}
                    </TableCell>
                    <TableCell>
                      {data.voucherDetails &&
                        data.voucherDetails.voucher.transactionDetails
                          .transactionDate}
                    </TableCell>
                  </TableRow>
                </TableBody> */}
							</Table>
						</Box>
					</Collapse>
				</TableCell>
			</TableRow>
		</React.Fragment>
	);
}

const headCells = [
	{
		id: "voucherNumber",
		numeric: true,
		disablePadding: true,
		label: "Voucher Number"
	},
	{
		id: "amount",
		numeric: true,
		disablePadding: false,
		label: "Amount"
	},
	// {
	//   id: "status",
	//   numeric: false,
	//   disablePadding: false,
	//   label: "Status",
	// },
	{
		id: "activationDate",
		numeric: true,
		disablePadding: false,
		label: "Activation Date"
	},

	{
		id: "redeemDate",
		numeric: true,
		disablePadding: false,
		label: "Redeemed Date"
	},
	{
		id: "expirationDate",
		numeric: true,
		disablePadding: false,
		label: "Expiration Date"
	}
];

export default function ExpiredTable({ data }) {
	const [order, setOrder] = useState("desc");
	const [orderBy, setOrderBy] = useState([]);
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const pages = [5, 10, 25];
	const [updateData, setUpdateData] = useState([data]);

	// const handleRequestSort = (property) => (_) => {
	//   const isAsc = orderBy === property && order === "desc";
	//   setOrder(isAsc ? "desc" : "asc");
	//   setOrderBy(property);
	// };

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleRequestSort = (property, order) => (_) => {
		if (order == "asc") {
			order = "desc";
			setOrder(order);
		} else {
			order = "asc";
			setOrder(order);
		}

		console.log(order);
		const updatedData = data.voucherDetails.voucher;
		// console.log(property);

		if (updatedData.length !== undefined) {
			if (
				property == "activationDate" ||
				property == "redeemDate" ||
				property == "expirationDate"
			) {
				//
				if (order == "desc") {
					const sorted = updatedData.sort(
						(a, b) => Date.parse(b[property]) - Date.parse(a[property])
					);
					// console.log("sorted " + JSON.stringify(sorted));
					setUpdateData(sorted);
				} else {
					const sorted = updatedData.sort(
						(a, b) => Date.parse(a[property]) - Date.parse(b[property])
					);
					// console.log("sorted " + JSON.stringify(sorted));
					setUpdateData(sorted);
				}
			} else {
				if (order == "desc") {
					const sorted = updatedData.sort((a, b) => b[property] - a[property]);
					// console.log("sorted " + JSON.stringify(sorted));
					setUpdateData(sorted);
				} else {
					const sorted = updatedData.sort((a, b) => a[property] - b[property]);
					// console.log("sorted " + JSON.stringify(sorted));
					setUpdateData(sorted);
				}
			}
		}
	};

	return (
		<React.Fragment>
			{data.status && !data.voucherDetails ? (
				<div></div>
			) : (
				// <Empty
				// 	image={Empty.PRESENTED_IMAGE_SIMPLE}
				// 	className="text-center my-4"
				// />
				<TableContainer component={Paper}>
					<Table aria-label="collapsible table">
						<TableHead>
							<TableRow>
								<TableCell padding="checkbox"></TableCell>
								{headCells.map((headCell) => (
									<TableCell
										key={headCell.id}
										// align={headCell.numeric ? "right" : "left"}
										// padding={headCell.disablePadding ? "none" : "normal"}
										sortDirection={orderBy === headCell.id ? order : false}
									>
										<TableSortLabel
											active={orderBy === headCell.id}
											direction={orderBy === headCell.id ? order : "asc"}
											onClick={handleRequestSort(headCell.id, order)}
											// direction={order}
										>
											{headCell.label}
										</TableSortLabel>
									</TableCell>
								))}
							</TableRow>
						</TableHead>
						<TableBody>
							{data.voucherDetails &&
								data.voucherDetails.voucher &&
								[]
									.concat(data.voucherDetails.voucher)
									.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
									.map((row) => <Row key={row.voucherId} row={row} />)}
						</TableBody>
					</Table>
					<TablePagination
						rowsPerPageOptions={[5, 10, 25]}
						component="div"
						count={
							data.voucherDetails &&
							data.voucherDetails.voucher &&
							data.voucherDetails.voucher.length === undefined
								? [1]
								: data.voucherDetails &&
								  data.voucherDetails.voucher &&
								  data.voucherDetails.voucher.length
						}
						rowsPerPage={rowsPerPage}
						page={page}
						onChangePage={handleChangePage}
						onChangeRowsPerPage={handleChangeRowsPerPage}
					/>
				</TableContainer>
			)}
		</React.Fragment>
	);
}
